module.exports = __webpack_public_path__ + "img/chevron-right.272565f7.svg";